import type { AxiosResponse } from 'axios'
import type { AxiosOptions } from 'shared/api'
import { baseApi } from 'entities/Auth'
import {
  type IResponseCreateReviewParams,
  type IResponseReview,
  type IResponseReviewDeleteImage,
  type IResponseReviewsList,
  type IResponseReviewUploadImage,
  type IReviewAccount,
  type IReviewDeleteImageParams,
  type IReviewParams,
  type IReviewsListParams,
  type IReviewUploadImageParams,
} from 'entities/Review/api/types'

class Api {
  createReview(params: IReviewParams): Promise<AxiosResponse<IResponseCreateReviewParams>> {
    return baseApi.post('reviews', params)
  }

  getReviews(
    params?: IReviewsListParams,
    options?: AxiosOptions
  ): Promise<AxiosResponse<IResponseReviewsList>> {
    return baseApi.get('reviews', { params, ...options })
  }

  getReviewById(id: number): Promise<AxiosResponse<IResponseReview>> {
    return baseApi.get(`reviews/${id}`)
  }

  updateReview(id: number, params: IReviewParams): Promise<AxiosResponse<IResponseReview>> {
    return baseApi.put(`reviews/${id}`, params)
  }

  deleteReview(id: number): Promise<void> {
    return baseApi.delete(`reviews/${id}`)
  }

  uploadReviewImage(
    params: IReviewUploadImageParams
  ): Promise<AxiosResponse<IResponseReviewUploadImage>> {
    return baseApi.post('reviews/image', params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  deleteReviewImage(
    params: IReviewDeleteImageParams
  ): Promise<AxiosResponse<IResponseReviewDeleteImage>> {
    return baseApi.delete('reviews/image', { data: params })
  }

  validateReviewAccount(params: IReviewAccount): Promise<AxiosResponse<IReviewAccount>> {
    return baseApi.post('reviews/accounts/validate', params)
  }
}

export const ReviewsApi = new Api()
